export default [
    {
      path: "/analysis",
      name: "analysis-chart",
      component: () => import("@/views/analysis/analysis.vue"),
      meta: {
        action: "read",
        // resource: "analysis-system",
        resource: "Auth",
      },
    },
    {
      path: "/report",
      name: "report",
      component: () => import("@/views/report/analysis.vue"),
      meta: {
        action: "read",
        // resource: "product-sales-report",
        resource: "Auth",
      },
    },
  ]